import { render, staticRenderFns } from "./DetailOrderLog.vue?vue&type=template&id=092bda10&scoped=true&"
import script from "./DetailOrderLog.vue?vue&type=script&lang=js&"
export * from "./DetailOrderLog.vue?vue&type=script&lang=js&"
import style0 from "./DetailOrderLog.vue?vue&type=style&index=0&id=092bda10&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "092bda10",
  null
  
)

export default component.exports